import { render, staticRenderFns } from "./StepSecond.vue?vue&type=template&id=583aff21&scoped=true&"
import script from "./StepSecond.vue?vue&type=script&lang=js&"
export * from "./StepSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583aff21",
  null
  
)

export default component.exports